var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconMailFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 2.5C1.22 2.5.176 3.466.03 4.707L12.5 12.5l12.47-7.793A2.492 2.492 0 0022.5 2.5h-20zM0 7.19V20a2.5 2.5 0 002.5 2.5h20A2.5 2.5 0 0025 20V7.19l-11.838 7.397a1.25 1.25 0 01-1.324 0L0 7.19z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}

export default SvgCommonIconMailFilled;